import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=d1703536&scoped=true&"
import script from "./menu-management.vue?vue&type=script&lang=js&"
export * from "./menu-management.vue?vue&type=script&lang=js&"
import style0 from "./menu-management.vue?vue&type=style&index=0&id=d1703536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1703536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1703536')) {
      api.createRecord('d1703536', component.options)
    } else {
      api.reload('d1703536', component.options)
    }
    module.hot.accept("./menu-management.vue?vue&type=template&id=d1703536&scoped=true&", function () {
      api.rerender('d1703536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-system-management/menu-management.vue"
export default component.exports